import { render, staticRenderFns } from "./PillPagination.vue?vue&type=template&id=2933c504"
import script from "./PillPagination.vue?vue&type=script&lang=js"
export * from "./PillPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports